var _path, _path2, _path3, _path4, _path5;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconReportAction(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 36,
    viewBox: "0 0 36 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.2521 17.332H21.6374C21.9268 17.332 22.1613 17.5812 22.1613 17.8887C22.1613 18.1961 21.9268 18.4453 21.6374 18.4453H14.2521C13.9627 18.4453 13.7282 18.1961 13.7282 17.8887C13.7282 17.5812 13.9627 17.332 14.2521 17.332Z",
    fill: "#517DDE"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M14.2521 20.6719H20.2739C20.5633 20.6719 20.7978 20.4227 20.7978 20.1152C20.7978 19.8078 20.5633 19.5586 20.2739 19.5586H14.2521C13.9627 19.5586 13.7282 19.8078 13.7282 20.1152C13.7282 20.4227 13.9627 20.6719 14.2521 20.6719Z",
    fill: "#517DDE"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M14.2521 21.7852H21.0004C21.2896 21.7852 21.5243 22.0343 21.5243 22.3418C21.5243 22.6493 21.2896 22.8984 21.0004 22.8984H14.2521C13.9627 22.8984 13.7282 22.6493 13.7282 22.3418C13.7282 22.0343 13.9627 21.7852 14.2521 21.7852Z",
    fill: "#517DDE"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M25.5277 12.4719L21.8744 8.65945C21.7764 8.55726 21.6446 8.5 21.5072 8.5H12.271C11.1932 8.5 10.3162 9.43165 10.3162 10.577V25.423C10.3162 26.5682 11.193 27.5 12.271 27.5H23.7297C24.8075 27.5 25.6845 26.5684 25.6845 25.423V12.869C25.6845 12.7196 25.628 12.5765 25.5277 12.4719ZM22.0311 10.3836L23.8795 12.3124H22.1977C22.1059 12.3124 22.0311 12.233 22.0311 12.1354V10.3836ZM23.7297 26.3867H12.271C11.7709 26.3867 11.364 25.9545 11.364 25.423V10.577C11.364 10.0455 11.7708 9.61328 12.271 9.61328H20.9835V12.1354C20.9835 12.8469 21.5283 13.4257 22.1979 13.4257H24.6367V25.423C24.6367 25.9545 24.2299 26.3867 23.7297 26.3867Z",
    fill: "#517DDE"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18 36C27.9411 36 36 27.9411 36 18C36 8.05887 27.9411 0 18 0C8.05887 0 0 8.05887 0 18C0 27.9411 8.05887 36 18 36ZM18 34.4C27.0575 34.4 34.4 27.0575 34.4 18C34.4 8.94253 27.0575 1.6 18 1.6C8.94253 1.6 1.6 8.94253 1.6 18C1.6 27.0575 8.94253 34.4 18 34.4Z",
    fill: "#517DDE"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconReportAction);
export default __webpack_public_path__ + "static/media/IconReportAction.faf5fc1ab5cf14f962dfa58d06b5e160.svg";
export { ForwardRef as ReactComponent };